import { render, staticRenderFns } from "./CbsModificationSet.vue?vue&type=template&id=07cfded8&scoped=true"
import script from "./CbsModificationSet.vue?vue&type=script&lang=js"
export * from "./CbsModificationSet.vue?vue&type=script&lang=js"
import style0 from "./CbsModificationSet.vue?vue&type=style&index=0&id=07cfded8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cfded8",
  null
  
)

export default component.exports